import { render, staticRenderFns } from "./IntegracaoDetalhes.vue?vue&type=template&id=135d6a30"
import script from "./IntegracaoDetalhes.vue?vue&type=script&lang=js"
export * from "./IntegracaoDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports